// Single source of truth for the public-facing company stats. Consumed by
// both the home-page hero proof-strip and the interactive-map header so the
// numbers can never drift apart.
//
// If a value changes, update it here only and both surfaces re-render with
// the new value at next build/reload.

export const COMPANY_STATS = [
  {
    key: 'years',
    value: '30',
    plus: '+',
    short: '30+',
    label: 'Years of Experience',
    shortLabel: 'Years',
  },
  {
    key: 'projects',
    value: '500',
    plus: '+',
    short: '500+',
    label: 'Projects Completed',
    shortLabel: 'Projects',
  },
  {
    key: 'states',
    value: '25',
    plus: '+',
    short: '25+',
    label: 'States Served',
    shortLabel: 'States',
  },
  {
    key: 'safety',
    value: '0',
    plus: '',
    short: '0',
    label: 'Safety Incidents',
    shortLabel: 'Safety',
  },
];
